import React from "react";
import NotificationsRouter from './Notification/Router';
export { getFields, getReplyFields } from './Notification/Router';

export default function NotificationPmRouter(props) {
    return (
        <NotificationsRouter {...props} mode='PM' />
    );
};
